import React from "react";
import cx from "classnames";
import styles from "./LinearLoading.module.css";
import { LinearProgress } from "@mui/material";

const LinearLoading = () => {
  return (
    <div className={cx(styles.container, "d-block", "position-fixed")}>
      <LinearProgress className={cx(styles.progressLoadingStyles)} />
    </div>
  );
};

export default LinearLoading;
